import Draggable from '@ui-kit/components/draggable';
import React from 'react';
import { Loader } from '@ui-kit/components/loader';
import { useTournamentScheme } from './hook/useTournamentScheme';
import styles from './finishedTournamentScheme.module.scss';
import TreeBlock from './treeBlock';

export const FinishedTournamentScheme = (props: { idTourney: string }) => {
  const { scheme, loading, error } = useTournamentScheme(props.idTourney);

  if (loading)
    return (
      <div style={{ position: 'relative', height: '100%' }}>
        <Loader />
      </div>
    );

  if (error) {
    return <h2>Error loading tournament scheme</h2>;
  }

  return (
    <Draggable className={styles.tournamentTree}>
      {scheme.final && <TreeBlock matchResults={scheme.final} title="Final" />}
      {scheme.winners && (
        <TreeBlock
          matchResults={scheme.winners}
          title={scheme.final && 'Upper bracket'}
        />
      )}
      {scheme.losers && (
        <TreeBlock matchResults={scheme.losers} title="Lower bracket" />
      )}
    </Draggable>
  );
};
